// extracted by mini-css-extract-plugin
module.exports = {"logoSlider":"LogoSlider_logoSlider__Ul8Qi","sliderContainer":"LogoSlider_sliderContainer___55h8","logoContainer":"LogoSlider_logoContainer__Nfwn6","logo":"LogoSlider_logo__p7T3Z"};